export default __webpack_public_path__ + "static/media/h1.9b8fc04f.jpg";